import { useContext, useState } from "react";
import { Grid } from "@mui/material";
import { InnerWrapper, MainContainer, TitleAndActionBox } from "../../common";
import { UBButton } from "../../../Libraries";
import { LanguageContext } from "../../../context/LanguageContext";
import { useLocation, useNavigate } from "react-router-dom";
import SaleList from "../../container/Sales";
import withObservables from "@nozbe/with-observables";
import {
  observeAllSaleByBusinessCount,
  observeQuickSaleByBusinessCount,
  observeSaleInvoicesByBusinessCount,
} from "../../../database/helpers/invoice";
import NonIdealNew from "../../common/NonIdealNew";
import { PlayIcon } from "../../../assets/icons/icon";
import { VideoModal } from "../../common/Modals";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { useAuthContext } from "../../../context/AuthContext";
import { sentenceCase } from "../../../constants";

const Sales = ({ invoicesCount, invoiceListCount, quickSaleListCount }) => {
  const [I18n] = useContext(LanguageContext);
  const { business, user } = useAuthContext();
  const location = useLocation();
  const navigate = useNavigate();

  const isNonIdeal = invoicesCount <= 0;

  const handleAddQuickSale = () => {
    triggerLogEvent(analytics, "quick_sale_create");
    navigate("/QuickSale/QuickSaleForm", {
      state: {
        pathname: location.pathname,
        data: quickSaleListCount,
      },
    });
  };

  const handleAddSaleInvoice = () => {
    triggerLogEvent(analytics, "inv_create");
    navigate("/InvoiceBook/Create", {
      state: {
        pathname: location.pathname,
        data: invoiceListCount,
      },
    });
  };

  return (
    <MainContainer fluid className="quickSalePage">
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title: (
                <span
                  className="newLightColor fontWeight400"
                  style={{ fontSize: "14px", marginRight: "3px" }}
                >
                  <span className="newFontColor fontWeight500" style={{ fontSize: "24px" }}>
                    {sentenceCase(I18n.sales)}{" "}
                  </span>
                  ({I18n.unified_view_of_quick_sale_invoice_and_pos})
                </span>
              ),
            }}
          >
            <UBButton
              onClick={handleAddQuickSale}
              id={"create_quick_sale"}
              className="ubPrimaryButton fontSize12 fontWeight400 textUppercase marginLeft12"
              title={I18n.quick_sale}
            />

            <UBButton
              onClick={handleAddSaleInvoice}
              id={"create_invoice"}
              className="ubPrimaryButton fontSize12 fontWeight400 textUppercase marginLeft12"
              title={I18n.sale_invoice}
            />
          </TitleAndActionBox>
          <InnerWrapper className="innerWrapper newInnerWrapper">
            {isNonIdeal ? (
              <NonIdealNew
                title={I18n.all_your_sales_in_one_place}
                subtitle={
                  I18n.manage_all_your_quick_sale_invoices_and_pos_transactions
                }
                button1Title="quick_sale"
                // button2Title="watch_video"
                onButton1Click={handleAddQuickSale}
                loading={false}
                disabledOne={false}
                disabledTwo={false}
                buttonOneId={"create_quick_sale"}
                buttonTwoId={"watch_video"}
                prefixIconButtonTwo={
                  <PlayIcon width="18px" height="18px" fill="var(--blue500)" />
                }
                listButton2Title={"sale_invoice"}
                onListButton2Click={handleAddSaleInvoice}
                listButtonTwoId="add_sale_invoice"
                video_footer={{
                  title: I18n.quick_sale,
                  onClick: handleAddQuickSale,
                }}
                video_url={
                  "https://www.youtube.com/embed/KpMpGauNeDc?si=_xvfwB-A25WKNQO1"
                }
                videoTitle={I18n.all_your_sales_in_one_place}
                videoSubtitle={
                  I18n.manage_all_your_quick_sale_invoices_and_pos_transactions
                }
              />
            ) : (
              <SaleList
                quickSaleListCount={quickSaleListCount}
                business={business}
                user={user}
                invoicesCount={invoicesCount}
              />
            )}
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

const enhance = withObservables([], () => ({
  invoicesCount: observeAllSaleByBusinessCount(localStorage.getItem("business_id")),
  invoiceListCount: observeSaleInvoicesByBusinessCount(
    localStorage.getItem("business_id"),
  ),
  quickSaleListCount: observeQuickSaleByBusinessCount(
    localStorage.getItem("business_id"),
  ),
}));

export default enhance(Sales);
